<template>
  <div @click="$emit('click')" class="div2-item">
    <div>({{wdy[date.weekday()]}})</div>
    <div>{{date.format('M/D')}}</div>
    <div>
      <div>
        <div>正職</div>
        <div>{{staffs || 0}}</div>
      </div>
      <div>
        <div>PT</div>
        <div>{{pts || 0}}</div>
      </div>
      <div>
        <div>總數</div>
        <div :style="{color: 'var(--color-number)'}">
        <div :style="{fontWeight: 700}">{{all || 0}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['index', 'date', 'data'],
  data () {
    return {
      wdy: ['日', '一', '二', '三', '四', '五', '六', '日']
    }
  },
  computed: {
    data2 () {
      if (this.data) {
        const data = JSON.parse(JSON.stringify(this.data))[this.date.format('yyyy-MM-DD')]
        if (data) {
          if (data.result) {
            delete data.result
          }
          return data
        } else {
          return {}
        }
      } else {
        return {}
      }
    },
    staffs () {
      if (this.data) {
        return Array.from(new Set([].concat(...Object.values(this.data2).map(e => e.staffs.map(a => a._id))))).length
      } else {
        return 0
      }
    },
    pts () {
      if (this.data) {
        return Array.from(new Set([].concat(...Object.values(this.data2).map(e => e.pts.map(a => a._id))))).length
      } else {
        return 0
      }
    },
    all () {
      if (this.data) {
        return this.pts + this.staffs
      } else {
        return 0
      }
    }
  }
}
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.div2-item {
  flex:1;
  &.selected {
    background-color: var(--color-infobox);
  }
  &>div:not(:last-child) {
    border-bottom: 1px solid #DADADA;
    min-height: 1em;
  }
  &>div{
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &>div:nth-child(1) {
    height: 35px;
    background-color: var(--color-checked);
    color: #FFFFFF;
    font-weight: 500;
    font-size: 16px;
    line-height: 27px;
    letter-spacing: 0.1em;
  }
  &>div:nth-child(2) {
    height: 60px;
    color: var(--color-checked);
    font-weight: 500;
    font-size: 20px;
    line-height: 27px;
    text-align: center;
    letter-spacing: 0.1em;
  }
  &>div:nth-child(3) {
    flex-direction: column;
    padding-block: 15px;
    gap: 5px;
    padding-inline: 24px;
    &>div{
      width: 100%;
      height: 27px;
      font-weight: 700;
      display: flex;
      align-items: center;
      justify-content: space-between;
      &>div:nth-child(1) {
        color: #848484;
        font-weight: 400;
        font-size: 14px;
        line-height: 27px;
        /* identical to box height, or 193% */

        letter-spacing: 0.1em;
      }
      &>div:nth-child(2) {
        color:var(--color-checked);
        font-weight: 700;
        font-size: 18px;
        line-height: 27px;
        /* identical to box height, or 150% */

        text-align: center;
        letter-spacing: 0.1em;

      }
    }
  }
  &:not(:last-child) {
    border-right: 1px solid #DADADA;
  }
}
</style>
